import React from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import Select from 'react-select';
import { FaSearch, FaTimes } from 'react-icons/fa';
import { selectStylesSm, customStyles } from '~/Styles/reactSelectStyles';

// Paridade Delphi: uLancaDespesaCartao.dfm:790-792 — cbMoeda aceita apenas Real e Dólar.
const OPCOES_MOEDA = [
  { value: 'R', label: 'Real' },
  { value: 'D', label: 'Dólar' },
];

const FiltrosDespesaCartao = ({
  filtros,
  onChange,
  onBuscar,
  onLimpar,
  opcoesGE,
  opcoesCartao,
  loading,
}) => {
  const handleChange = (campo, valor) => {
    onChange({ ...filtros, [campo]: valor });
  };

  return (
    <Form onSubmit={(e) => { e.preventDefault(); onBuscar(); }}>
      <Row className="align-items-end">
        <Col xs={12} md={4} className="mb-2">
          <Form.Label className="small mb-1">Grupo Empresa</Form.Label>
          <Select
            isMulti
            styles={selectStylesSm}
            options={opcoesGE}
            value={opcoesGE.filter((o) => (filtros.codigos_grupo_empresa || []).includes(o.value))}
            onChange={(sel) => handleChange('codigos_grupo_empresa', (sel || []).map((s) => s.value))}
            placeholder="Selecione..."
            noOptionsMessage={() => 'Nenhuma GE'}
          />
        </Col>
        <Col xs={12} md={3} className="mb-2">
          <Form.Label className="small mb-1">Cartão</Form.Label>
          <Select
            isClearable
            styles={customStyles}
            options={opcoesCartao}
            value={opcoesCartao.find((o) => o.value === filtros.cartao) || null}
            onChange={(sel) => handleChange('cartao', sel ? sel.value : null)}
            placeholder="Todos"
            noOptionsMessage={() => 'Nenhum cartão'}
          />
        </Col>
        <Col xs={6} md={2} className="mb-2">
          <Form.Label className="small mb-1">Venc. De</Form.Label>
          <Form.Control
            type="date"
            value={filtros.vencimento_inicio || ''}
            onChange={(e) => handleChange('vencimento_inicio', e.target.value || null)}
          />
        </Col>
        <Col xs={6} md={2} className="mb-2">
          <Form.Label className="small mb-1">Venc. Até</Form.Label>
          <Form.Control
            type="date"
            value={filtros.vencimento_fim || ''}
            onChange={(e) => handleChange('vencimento_fim', e.target.value || null)}
          />
        </Col>
        <Col xs={6} md={2} className="mb-2">
          <Form.Label className="small mb-1">Compra De</Form.Label>
          <Form.Control
            type="date"
            value={filtros.data_compra_inicio || ''}
            onChange={(e) => handleChange('data_compra_inicio', e.target.value || null)}
          />
        </Col>
        <Col xs={6} md={2} className="mb-2">
          <Form.Label className="small mb-1">Compra Até</Form.Label>
          <Form.Control
            type="date"
            value={filtros.data_compra_fim || ''}
            onChange={(e) => handleChange('data_compra_fim', e.target.value || null)}
          />
        </Col>
        <Col xs={12} md={3} className="mb-2 d-flex align-items-end" style={{ gap: 8 }}>
          <Form.Check
            type="checkbox"
            id="mostrar-fechadas"
            label="Mostrar já fechadas"
            checked={filtros.mostrar_fechadas || false}
            onChange={(e) => handleChange('mostrar_fechadas', e.target.checked)}
            className="mb-1"
          />
        </Col>
        <Col xs={12} md="auto" className="mb-2 d-flex" style={{ gap: 8 }}>
          <Button variant="primary" type="submit" disabled={loading}>
            <FaSearch className="mr-1" /> Buscar
          </Button>
          <Button variant="outline-secondary" type="button" onClick={onLimpar} disabled={loading}>
            <FaTimes className="mr-1" /> Limpar
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default FiltrosDespesaCartao;
